import React from 'react';
import styled from '@emotion/styled';

interface CommonColumnProps {
  value: any;
  width?: string | number;
  minWidth?: string | number;
  className?: string;
}

export default React.memo((props: CommonColumnProps) => {
  return (
    <StyledColumnContent className={props?.className || ''} style={{ width: props.width, minWidth: props.minWidth }}>
      {props?.value}
    </StyledColumnContent>
  );
});

const StyledColumnContent = styled.div`
  //
`;
